export function BasketHeader(props) {
    const renderCount = () => `Cart ${props.itemsCount > 0 ? `(${props.itemsCount})` : ''} `;

    return <>
        <div className="align-center pointer" onClick={e => props.toggleBascket(e, true)} >
            {props.showText ? (
                <span className="underline">{props.showText}</span>
             ) : (
            <>
            <span className="curtains-icon curtains-icon-teenyicons_bag-minus-outline size-24 me-6"></span>
                <span className="caption3">
                    {renderCount()}
                </span>
            </>
            )}
        </div>
    </>;
}
